import { createContext, Dispatch } from "react";
import { InlineEditorAction } from "./InlineEditorActions";
import { initialState, InlineEditorState } from "./InlineEditorState";

export const InlineEditorContext = createContext<{
    state: InlineEditorState;
    dispatch: Dispatch<InlineEditorAction>;
}>({
    state: initialState,
    dispatch: () => null,
});
